<template>
  <g>
    <path
      d="M10 12.0002C12.2091 12.0002 14 10.2094 14 8.00024C14 5.79111 12.2091 4.00024 10 4.00024C7.79086 4.00024 6 5.79111 6 8.00024C6 10.2094 7.79086 12.0002 10 12.0002Z"
    />
    <path
      d="M10.35 14.0103C7.62 13.9103 2 15.2703 2 18.0003V19.0003C2 19.5503 2.45 20.0003 3 20.0003H11.54C9.07 17.2403 10.31 14.1103 10.35 14.0103Z"
    />
    <path
      d="M19.43 18.0203C19.9 17.2203 20.13 16.2503 19.91 15.2003C19.57 13.5603 18.19 12.2503 16.53 12.0403C13.9 11.7003 11.68 13.9103 12.03 16.5403C12.25 18.2003 13.55 19.5803 15.19 19.9203C16.24 20.1403 17.21 19.9103 18.01 19.4403L19.87 21.3003C20.26 21.6903 20.89 21.6903 21.28 21.3003C21.67 20.9103 21.67 20.2803 21.28 19.8903L19.43 18.0203ZM16 18.0003C14.9 18.0003 14 17.1003 14 16.0003C14 14.9003 14.9 14.0003 16 14.0003C17.1 14.0003 18 14.9003 18 16.0003C18 17.1003 17.1 18.0003 16 18.0003Z"
    />
  </g>
</template>
